const routes = [
  {
    path: '/auth',
    component: () => import('layouts/login-layout.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('pages/auth/index.vue'),
        meta: {
          auth: false,
          roles: ['']
        }
      },
      {
        path: 'plo',
        name: 'plo',
        component: () => import('pages/auth/IndexPLO.vue'),
        meta: {
          auth: false,
          roles: ['']
        }
      },
      {
        path: 'reset-password/:token',
        name: 'reset-password',
        component: () => import('pages/auth/ResetPasswordPage.vue'),
        meta: {
          auth: false,
          roles: ['']
        }
      }
    ]
  },
  {
    path: '/',
    component: () => import('layouts/main-layout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('pages/index-page.vue'),
        meta: {
          roles: ['proexi_group', 'client', 'driver']
        }
      },
      {
        path: '/detail/:id',
        name: 'detail',
        component: () => import('pages/detail/index.vue'),
        meta: {
          roles: ['proexi_group', 'client', 'driver']
        }
      },
      /* {
        path: '/report/:id',
        name: 'report',
        component: () => import('pages/detail/report-breakdown-page.vue'),
        meta: {
          roles: ['proexi_group', 'client','driver']
        }
      }, */
      {
        path: '/add-update/:id',
        name: 'add-update',
        component: () => import('pages/detail/add-update-page.vue'),
        meta: {
          roles: ['proexi_group', 'driver']
        }
      },
      {
        path: '/devices',
        name: 'devices',
        component: () => import('pages/devices/index.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/follow',
        name: 'follow',
        component: () => import('pages/follow/follow-index.vue'),
        meta: {
          roles: ['proexi_group', 'client', 'driver']
        }
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('pages/account/index.vue'),
        meta: {
          roles: ['proexi_group', 'client', 'driver']
        }
      },
      {
        path: '/qr',
        name: 'qr',
        component: () => import('pages/devices/qr.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/devices-detail/:id',
        name: 'devices-detail',
        component: () => import('pages/devices/detail.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/menu',
        name: 'menu',
        component: () => import('pages/menu.vue'),
        meta: {
          roles: ['proexi_group', 'client', 'driver']
        }
      },
      {
        path: '/notifications',
        name: 'notifications',
        component: () => import('pages/notifications/index.vue'),
        meta: {
          roles: ['proexi_group', 'client', 'driver']
        }
      },
      {
        path: '/requests',
        name: 'requests',
        component: () => import('pages/requests/requests-index.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/requests-detail/:id',
        name: 'request-detail',
        component: () => import('pages/requests/request-detail.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/requests/create',
        name: 'request-create',
        component: () => import('pages/requests/request-create.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/scan-order',
        name: 'scan-order',
        component: () => import('pages/scan-order/scan-order-page.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      },
      {
        path: '/assignment',
        name: 'assignment',
        component: () => import('pages/assignment-page.vue'),
        meta: {
          roles: ['proexi_group']
        }
      },
      {
        path: '/assignment-success',
        name: 'assignment-success',
        component: () => import('pages/assignment-success-page.vue'),
        meta: {
          roles: ['proexi_group']
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('pages/dashboard/index.vue'),
        meta: {
          roles: ['proexi_group', 'client']
        }
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/error-not-found.vue')
  }
]

export default routes
